import React, { useEffect, useState } from "react"

function renderPrice(priceInt) {
    let roundedPrice = (Math.round(priceInt * 100) / 100)
    let perMonthString = Number.parseFloat(roundedPrice).toFixed(2) + " €"
    return (perMonthString)
}
export default renderPrice